import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { getUserData } from "../../helpers/utils";
import Select2 from "../Common/Select2Wrapper";
import CustomToastContainer from "../Common/CustomToastContainer";
import api from "../../Api";
import FeatherIcon from "feather-icons-react";
import default123 from "../../image/DefaultImage.png";

const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;

const ManageBlogs = () => {
  const history = useHistory();
  const toastRef = useRef();
  const User = getUserData();
  const [render, setRender] = useState(0);
  const [data, setdata] = useState([]);

  const handleDelete = async (id) => {
    const response = await api.deleteBlog(`${id}`);
    if (response.status === 200) {
      toastRef.current.addToast(response.msg, "success");
      setRender((prev) => prev + 1);
    } else {
      toastRef.current.addToast(
        "There was an error deleting the blog!",
        "error"
      );
    }
  };

  const status = [
    { id: "draft", text: "Draft" },
    { id: "published", text: "Published" },
    { id: "archived", text: "Archived" },
  ];

  const handleUpdateStatus = async (e, id) => {
    e.preventDefault();
    const formdata = { status: e.target.value };

    try {
      const res = await api.updateBlogstatus(id, formdata);
      if (res.status === 200) {
        toastRef.current.addToast("Status Updated Successfully", "success");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      toastRef.current.addToast("Error updating status", "error");
    }
  };

  const columns = [
    {
      name: "Image",
      selector: (row) =>
        row?.featured_image && row?.featured_image !== "null" ? (
          <img
            className="image"
            width={60}
            height={60}
            src={`${domainpath}/uploads/${row.featured_image}`}
            alt="Featured"
          />
        ) : (
          <img
            className="image"
            width={60}
            height={60}
            src={default123}
            alt="Default"
          />
        ),
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => (
        <a
          href={`https://hirepros.co.uk/blogs/${row.slug}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.title}
        </a>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="relative job-search-label-section singleselect2 statusenroll">
          <Select2
            data={status}
            className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
            defaultValue={row.status}
            onChange={(e) => handleUpdateStatus(e, row._id)}
            options={{
              placeholder: "Select Status",
              width: "100%",
              theme: "classic",
            }}
          />
        </div>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2 w-full item-center justify-center">
          <button
            className="manage-edit-btn text-white px-6 py-2"
            onClick={() => history.push(`./edit-blog/${row._id}`)}
          >
            <FeatherIcon icon="edit-2" />
          </button>
          <button
            className="manage-delete-btn text-white px-6 py-2"
            onClick={() => handleDelete(row._id)}
          >
            <FeatherIcon icon="trash" />
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    async function getBlogs() {
      try {
        const response = await api.getBlogs();
        if (response.status === 200) {
          setdata(response.blogs);
        }
      } catch (error) {
        console.error("Error fetching blogs", error);
      }
    }
    getBlogs();
  }, [render]);

  const tableData = {
    columns,
    data,
  };

  return (
    <div className="py-8">
      <div className="bg-white p-4 rounded-lg shadow">
        <div className="flex justify-between">
          <h2 className="text-lg font-bold mb-4" style={{ color: "#003366" }}>
            Manage Blogs
          </h2>
          <button
            className="manage-add-btn text-white px-3 py-1 Job-Post-btn"
            onClick={() => history.push(`./add-blog`)}
          >
            Add Blogs
          </button>
        </div>
        <DataTableExtensions {...tableData}>
          <DataTable
            columns={columns}
            data={data}
            defaultSortField="id"
            defaultSortAsc={false}
            pagination
            highlightOnHover
          />
        </DataTableExtensions>
      </div>

      <CustomToastContainer ref={toastRef} />
    </div>
  );
};

export default ManageBlogs;
